import 'babel-polyfill';
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import axios from 'axios';

import initGreySelect from '../greySelect';
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.min.css';
import initSimpleCollapse from '../simpleCollapse';

class PriceRangeSelect {

    constructor(priceRangeSelect, max=null, min=null) {
        //class variable
        this.priceRangeSelect = priceRangeSelect;
        this.minPriceInput = priceRangeSelect.find('input[name=min_price]');
        this.maxPriceInput = priceRangeSelect.find('input[name=max_price]');
        this.minPriceDisplay = priceRangeSelect.find('.min-price-display');
        this.maxPriceDisplay = priceRangeSelect.find('.max-price-display');
        this.priceSelected = priceRangeSelect.find('.selected-price');

        //class method requiring bind this
        this.updateSlider = this.updateSlider.bind(this);
        //init select
        this.priceRangeSelect.on('select2:opening', (e) => {
            e.preventDefault();
            this.toogle();
        });

        //init price range slider
        const priceRangeSlider = document.getElementById('price-range-slider');
        if(priceRangeSlider !== null) {
            noUiSlider.create(priceRangeSlider, {
                start: [ this.minPriceInput.val(), this.maxPriceInput.val() ],
                connect: true,
                step: 100,
                range: {
                    'min': min !== null ? min : parseInt(this.minPriceInput.attr('min')),
                    'max': max !== null ? max : parseInt(this.maxPriceInput.attr('max'))
                },
            });
        }
        //assign update handler
        priceRangeSlider.noUiSlider.on('update', this.updateSlider);

        //assign on click handler to clear button
        this.priceRangeSelect.find('button').on('click', (e) => {
            e.stopPropagation();
            priceRangeSlider.noUiSlider.reset();
        });

        //hide select when click outside the select
        this.priceRangeSelect.on('click', (e) => e.stopPropagation());
        $(body).on('click', (e) => {
            if(this.priceRangeSelect.hasClass('active')) {
                $(e.target).closest('#price-range-select .dropdown').length === 0 && this.hide();
            }
        });


    }

    show() { this.priceRangeSelect.addClass('active') }
    hide() { this.priceRangeSelect.removeClass('active') }
    toogle() { this.priceRangeSelect.hasClass('active') ? this.hide() : this.show(); }

    updateMaxPrice(value) {
        this.maxPriceDisplay.html(`$${value}`);
        this.maxPriceInput.val(value);
    }
    updateMinPrice(value) {
        this.minPriceDisplay.html(`$${value}`);
        this.minPriceInput.val(value);
    }

    updateSlider(values, handle) {
        const value = parseInt(values[handle]);
        handle ? this.updateMaxPrice(value) : this.updateMinPrice(value);
        this.priceSelected.html(`$${parseInt(values[0])}-${parseInt(values[1])}`);
    }

}

function bindProductPhotoEvent() {
    $('.product-photo')
        .on('mouseenter', function(e) {
            if(this.dataset.hoverPhotoFilepath !== '') {
                this.src = this.dataset.hoverPhotoFilepath;
            }
        })
        .on('mouseout', function(e) {
            this.src = this.dataset.photoFilepath;
        })
}

$(document).ready(function () {

    //grey select
    initGreySelect();

    if($('#price-range-select').length > 0) {
        new PriceRangeSelect($('#price-range-select'));
    }

    $("#sort-form select[name=sort]").on('change', (e) => {
        $(e.target).closest('form').submit();
    })

    bindProductPhotoEvent();
    initSimpleCollapse();

});

function generateProductsApiParams() {
    const params = {};
    if($('#product-list-container').length > 0) {
        if(product_category_name) {params.product_category_name = product_category_name;}
        if(product_subcategory_name) {params.product_subcategory_name = product_subcategory_name;}
    }else if($('#shop-all-container').length > 0) {
        params.product_range = $('select[name=product_range]').val();
    }
    params.occasion_id = $('.search-box select[name=occasion_id]').val();
    params.sort = $('.search-box select[name=sort]').val();
    params.max_price = $('.search-box input[name=max_price]').val();
    params.min_price = $('.search-box input[name=min_price]').val();
    return params;
}

window[vmName] = new Vue({
    el: vmSelector,
    data: {
        products: [],
        productsPage: 1,
        maxProductPage,
        productDetailUrl,
        isLoadingNewProducts: false
    },
    computed: {
        isShowLoadMoreBtn() {
            return !this.isLoadingNewProducts && this.productsPage !== this.maxProductPage
        }
    },
    methods: {
        getProducts() {
            if(this.isLoadingNewProducts || this.productsPage >= this.maxProductPage) {
                return;
            }
            this.isLoadingNewProducts = true;
            const params = {
                page: ++this.productsPage,
                ...generateProductsApiParams()
            };
            axios.get(getProductsApiUrl, {
                params
            }).then(res => {
                if(Array.isArray(res.data)) {
                    this.products.push(...res.data);
                }
                this.isLoadingNewProducts = false;
            });
        }
    },
    mounted() {
        const scrollHandler = (e) => {
            if(this.isLoadingNewProducts) {
                return;
            }
            const el = $(e.target);
            const lastProductItem = $('.product-item:last-child');
            if((el.scrollTop() + el.height()) >= (lastProductItem.position().top + lastProductItem.height())) {
                this.getProducts();
            }
        };
        $('#content-container').scroll(_.debounce(scrollHandler, 100));
        bindProductPhotoEvent();
    },
    updated() {
        bindProductPhotoEvent();
    }
});

